import localStorageKeys from "./localStorageKeys";

const setToken = (token) => {
  localStorage.setItem(localStorageKeys.token, token);
};

export default setToken;
